import React, { Fragment } from "react";

import GreenLogo from "./GreenLogo";

const CancelUserRequestBusinessCasualConfirm = ({
  user,
  notification,
  setcancelbusinessrequestoverlay,
  profile: { avatar, firstname, lastname, jobtitle, location },
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="subscription-box-confirmation">
          <i
            className="far fa-times-circle green fa-3x subscription-x"
            onClick={() =>
              setcancelbusinessrequestoverlay({
                request: false,
                confirm: false,
              })
            }
          ></i>
          <div className="subscription-type-container">
            <p className="nav-logo">
              <GreenLogo />
            </p>
            <h1 className="subscription-name green">Un-Follow User</h1>
          </div>
          <div className="sub-grid-three">
            <div className="subscription-user">
              <div className="sub-section-container">
                <div className="flex-only">
                  <i className="fas fa-user-circle mr-5 fa-lg mt-5 green"></i>
                  <p className="sub-section green">
                    Request to un-follow user:
                  </p>
                </div>
              </div>
              <div className="sub-user">
                <div className="online-avi-container">
                  <div className="avi-color-border-alt green">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                      className="sub-avi"
                      alt="avi"
                    />
                  </div>
                </div>
                <div className="sub-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="green name-font bold">
                        {firstname} {lastname}
                      </span>
                    </li>
                    <li className="user-online-item">{jobtitle}</li>
                    <li className="user-online-item">
                      {location.city}, {location.state}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="subscription-user">
              <div className="sub-section-container">
                <div className="flex-only">
                  <i className="fas fa-user-circle mr-5 fa-lg mt-5 green"></i>
                  <p className="sub-section green">Un-follow request from:</p>
                </div>
              </div>
              <div className="sub-user">
                <div className="online-avi-container">
                  <div className="avi-color-border-alt green">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                      className="sub-avi"
                      alt="avi-two"
                    />
                  </div>
                </div>
                <div className="sub-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="green name-font bold">
                        {user.firstname} {user.lastname}
                      </span>
                    </li>
                    <li className="user-online-item">{user.jobtitle}</li>
                    <li className="user-online-item">
                      {user.location.city}, {user.location.state}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="sub-grid">
            <p className="user-request-text">
              {notification && notification.msg}
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CancelUserRequestBusinessCasualConfirm;
